import React from "react";

const HomePage = (props) => {
  return <div />;
};

export default HomePage;
